<template>
    <div>
      <patent-bulletin-check-list></patent-bulletin-check-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  